// extracted by mini-css-extract-plugin
export var locationCard = "_gy-0";